import React from 'react'
import { Form, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { connect } from "react-redux";

function TablePage(props) {
    const { t } = useTranslation();
  return (
    <Table striped className={"w-100 common_table"}>
        <thead>
            <tr>
                {props?.headData?.map((item, index)=>(
                    <th key={index?.toString()}>{item}</th>
                ))}

            <th className={"text-center"}>{t("pages.catalog.action")}</th>
            </tr>
        </thead>
        <tbody>
            {props?.data?.filter((label) =>
                label?.title
                ?.toLowerCase()
                .includes(props?.search?.toLowerCase())
            )
            .map((item, index) => (
                <tr
                onClick={(e) => props?.onClick(item)}
                key={index.toString()}
                >
                <td>
                    <LazyLoadImage
                    alt={"."}
                    className={"subcata-image"}
                    onError={(event) => {
                        event.target.src = props?.default_img;
                    }}
                    src={
                        item?.image_url === null
                        ? props?.default_img
                        : item?.image_url
                    }
                    />
                </td>
               {props?.title && (<td>
                    {props?.language === "En" ? item?.title : item?.title_in_tr}
                </td>)}
               {props?.description &&
                (<td>
                    <p className="description">
                    {props?.language === "En"
                        ? item?.description
                        : item?.description_in_tr}
                    </p>
                </td>)}
                <td className={"text-center"}>
                    <Form.Check
                    className="form_checklist"
                    id={item?.id}
                    name={"is_check"}
                    onChange={(e) => props?.onClick(item)}
                    checked={item?.is_check}
                    />
                </td>
                </tr>
            ))}
        </tbody>
    </Table>
  )
}
const mapStateToProps = (state) => ({
    language: state?.languageState?.language,
  });
  
  export default connect(mapStateToProps)(TablePage);